import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import typographyStyles from '../Typography/Typography.module.scss';
export function TableListItem(props) {
    const { columnDef, item, children, testId } = props;
    if (!columnDef) return null;
    const { width: columnWidth, hAlign } = columnDef;
    const isResponsive = Array.isArray(columnWidth);
    const width = typeof columnWidth === 'number' ? columnWidth : null;
    const minWidth = isResponsive ? columnWidth[0] : columnWidth;
    const maxWidth = isResponsive ? columnWidth[1] : columnWidth;
    const fluid = minWidth ? 1 : null;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": item.testId || testId,
        className: cn({
            [typographyStyles["".concat(item.weight, "Weight")]]: item.weight,
            [typographyStyles.ellipsis]: item.ellipsis,
            [typographyStyles.root]: item.skin,
            [typographyStyles["".concat(item.skin, "Skin")]]: item.skin,
            [typographyStyles["".concat(item.variant, "Variant")]]: item.variant
        }, item.className),
        style: _object_spread_props(_object_spread({
            textAlign: hAlign || 'left'
        }, isResponsive ? {
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: minWidth,
            minWidth: 0,
            overflow: 'hidden'
        } : {
            width,
            minWidth,
            flex: fluid
        }), {
            maxWidth,
            alignSelf: 'center'
        }),
        children: children || item.value
    });
}
